import React from 'react';
import { Link } from 'react-router-dom';
import { openConsentSettings } from '../lib/consent';
import './Footer.css';

export default function Footer() {
    return (
        <footer className="footer">
            {/* data-nosnippet: stoppar Google från att bygga sökresultatens
                utdragstext av sidfotens kontaktuppgifter */}
            <div className="container" data-nosnippet="true">
                <div className="footer-cta">
                    <div className="footer-cta-text">
                        <h2>Osäker? Börja med en gratis prototyp</h2>
                        <p>Betala först när du är nöjd.</p>
                    </div>
                    <div className="footer-cta-actions">
                        <a href="/#contact" className="btn-primary">Få en gratis prototyp</a>
                        <Link to="/priskalkylator" className="footer-cta-link">Räkna ut ditt pris →</Link>
                    </div>
                </div>

                <div className="footer-grid">
                    <div className="footer-col">
                        <h3>Briljans</h3>
                        <p>Stångtjärnsvägen 210</p>
                        <p>791 74 Falun</p>
                        <p>Verksamma i hela Sverige</p>
                        <p>Godkänd för F-skatt</p>
                    </div>

                    <div className="footer-col">
                        <h3>Tjänster</h3>
                        <Link to="/webbdesign">Webbdesign</Link>
                        <Link to="/e-handel">E-handel</Link>
                        <Link to="/skraddarsydda-system">Skräddarsydda system</Link>
                        <Link to="/seo">SEO</Link>
                        <Link to="/hemsida-falun">Hemsida i Falun</Link>
                        <Link to="/priskalkylator">Priskalkylator</Link>
                        <Link to="/blogg">Blogg</Link>
                    </div>

                    <div className="footer-col">
                        <h3>Juridiskt</h3>
                        <Link to="/integritetspolicy">Integritetspolicy</Link>
                        <Link to="/villkor">Villkor</Link>
                        <Link to="/cookies">Cookiepolicy</Link>
                        <button type="button" className="footer-consent-button" onClick={() => openConsentSettings()}>
                            Cookie-inställningar
                        </button>
                    </div>

                    <div className="footer-col">
                        <h3>Kontakt</h3>
                        <p><strong>Lucas:</strong> <a href="tel:0766140446">076-614 04 46</a> · <a href="mailto:lucas@briljansdesign.se">lucas@briljansdesign.se</a></p>
                        <p><strong>Hanna:</strong> <a href="tel:0703324587">070-332 45 87</a> · <a href="mailto:hanna@briljansdesign.se">hanna@briljansdesign.se</a></p>
                        <p><strong>Oliver:</strong> <a href="tel:0766161448">076-616 14 48</a> · <a href="mailto:oliver@briljansdesign.se">oliver@briljansdesign.se</a></p>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} Briljans. Alla rättigheter förbehållna.</p>
                </div>
            </div>
        </footer>
    );
}
